module.exports = __webpack_public_path__ + "static/media/android-1.beab01d6.jpg";